import { combineReducers } from 'redux';
import { withReduxStateSync } from '../lib/syncState';
import user from './user';

const appReducer = combineReducers({
    user
});

export default withReduxStateSync(appReducer);
